import { render, staticRenderFns } from "./AddFolderIcon.vue?vue&type=template&id=7ca1a1ca"
import script from "./AddFolderIcon.vue?vue&type=script&lang=js"
export * from "./AddFolderIcon.vue?vue&type=script&lang=js"
import style0 from "../../operations.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports